
//https://www.cpr.dk/media/17550/tegnsaet.pdf
const acceptedSpecialLetters = "\\'\\-\\.ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ"
const otherSpecialChars = "\\!\\$\\%\\&\\'\\(\\)\\*\\+\\,\\/\\:\\;\\<\\=\\>\\?\\@\\^\\_\\{\\}\\~"

export const ValidateCustomRegex = (input : string , regex : RegExp) => {
    return regex.test(input)
}

export const ValidateCpr = (input : string) => {
    let regex = RegExp("^\\d{10}$")
    return regex.test(input)
}

export const ValidateCvr = (input : string) => {
    let regex = RegExp("^\\d{8}$")
    return regex.test(input)
}

export const ValidateCardNumber = (input : string) => {
    let regex = RegExp("^[A-Z]{2}.{14}$")
    return regex.test(input)
}

export const ValidateDriverLicenseDk = (input : string) => {
    let regex = RegExp("^\\d{8}$")
    return regex.test(input)
}

export const ValidateDriverLicenseInt = (input : string) => {
    var maxLength = 16; // From Thales specification
    let regex = RegExp("^[\\w\\d\\-\\*]+$")
    return regex.test(input) && input.length <= maxLength
}

export const ValidateTextNoSpaces = (input : string) => {
    let regex = RegExp(`^([A-Za-z${acceptedSpecialLetters}])+$`)
    return regex.test(input)
}

export const ValidateTextWithSpaces = (input : string) => {
    let regex = RegExp(`^([A-Za-z${acceptedSpecialLetters}]|\\s)+$`)
    return regex.test(input)
}

export const ValidateTextWithSpacesAndNumbers = (input : string) => {

    let regex = RegExp(`^([0-9A-Za-z${acceptedSpecialLetters}${otherSpecialChars}]|\\s)+$`)
    return regex.test(input)
}

export const ValidateCommaSeparatedList = (input : string) => {
    let regex = RegExp("^(\\w|(, ))+$")
    return regex.test(input)
}

export const ValidateAutorisationsNr = (input : string) => {
    let regex = RegExp("^\\d{3}-[ADI]$")
    return regex.test(input)
}

export const ValidateAmountOfCards = (input : string) => {
    var minNrofCards = 1;
    var maxNrOfCards = 5;
    var inputValue = parseInt(input, 10)
    return minNrofCards <= inputValue && inputValue <= maxNrOfCards
}

export const ValidateTextWithSpacesMax35 = (input : string) => {
    var maxLength = 35
    return ValidateTextWithSpaces(input) && input.length <= maxLength
}

export const ValidateTextWithSpacesAndNumbersMax35 = (input : string) => {
    var maxLength = 35
    return ValidateTextWithSpacesAndNumbers(input) && input.length <= maxLength
}

export const ValidateWrxNr = (input: string) => {
    let regex = new RegExp("^(?!.*wrx)[0-9a-zA-Z]{4,10}$", "i");
    return regex.test(input);
}
